export function initOneSignal(): void {
    const appId = window.appConfig.oneSignalAppId;
    const user = window.appConfig.user;

    window.OneSignalDeferred = window.OneSignalDeferred || [];

    window.OneSignalDeferred.push(async (OneSignal) => {
        await OneSignal.init({
            appId: appId,
        });

        if (user?.id) {
            await OneSignal.login(String(user.id));
        }

        if (!OneSignal.Notifications.permission) {
            await OneSignal.Notifications.requestPermission();
        }
    });
}
